<template>
  <Header />
  <router-view></router-view>
  <Footer />
</template>
<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@700;900&family=Squada+One&display=swap");
</style>
<script>
import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  mounted() {
    this.detectBrowser();
  },
  watch: {
    $route(to) {
      console.log(to.name);
      if (to.name !== 'SignUp' && to.name != 'AddMember' &&
        to.name != "SendOtp" && to.name != "VerifyOtp" && to.name != "ResetPwd" &&
        to.name != "PermBookingCheck" && to.name != "PermBooking") {
        this.validateUserAndRedirect();
      }
    }
  },
  methods: {
    validateUserAndRedirect() {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token != null) {
        axios
          .get(`${process.env.VUE_APP_URL}/member/detail`, {
            headers: { Authorization: `Bearer ${token.token}` },
          })
          .then(() => {
            this.$store.commit("auth/setUser", token.token);
          })
          .catch(() => {
            // clear localStorage
            localStorage.removeItem("token");
            this.$store.commit("auth/setUser", null);
            this.$router.push(`/signIn`);
          });
      } else {
        // clear localStorage
        localStorage.removeItem("token");
        this.$store.commit("auth/setUser", null);
        this.$router.push(`/signIn`);
      }
    },
    detectBrowser() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      let isApp = false;
      if (/MicroMessenger/i.test(userAgent)) {
        isApp = true;
      } else if (userAgent.match(/FB/)) {
        isApp = true;
      } else if (/Instagram/i.test(userAgent)) {
        isApp = true;
      } else if (/Line/i.test(userAgent)) {
        window.location.href = '?openExternalBrowser=1';
      } else if (/Twitter/i.test(userAgent)) {
        isApp = true;
      } else if (/Snapchat/i.test(userAgent)) {
        isApp = true;
      } else if (/Weibo/i.test(userAgent)) {
        isApp = true;
      } else {
        isApp = false;
      }
      if (isApp) {
        alert("請使用Safari 或 Chrome 瀏覽器開啟");
        return;
      }
    }
  },
};
</script>

<style>
body {
  background: black !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

a:focus {
  outline: none;
  box-shadow: none;
}

* {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  -ms-user-select: none;
  /* IE 10+ */
  user-select: none;
}

input,
textarea {
  -webkit-user-select: auto !important;
}

.v-toast__item--error {
  background-color: #8e5356 !important;
  color: #fff;
}

.v-toast__item--success {
  background-color: #2b5eaa !important;
  color: #fff;
}

.v-toast__item.v-toast__item--top,
.v-toast__item.v-toast__item--bottom {
  width: 90% !important;
  height: 32px !important;
  margin-top: 46px !important;
}

.v-toast__icon {
  display: none !important;
}

.v-toast__text {
  text-align: center !important;
  width: 100% !important;
}

.v-toast__item {
  opacity: 1;
  min-height: 3.25em !important;
}
</style>
